import React, { useRef, useEffect, useState, useContext } from 'react';
import { makeStyles, useTheme } from '@mui/styles';
import PropTypes from 'prop-types';

import StyledTooltip from '../styled/tooltip';
import { GroupsContext } from '../../data/groups-service';

import {
    scaleLinear as D3scaleLinear,
    scaleOrdinal as D3scaleOrdinal,
    format as D3format,
} from 'd3';

const useStyles = makeStyles(theme => ({
    root: {
    },
    bar: {
        display: 'inline-block',
        marginTop: 0,
    },
    value: {
        lineHeight: '1em',
        fontSize: '.75em',
        padding: 10,
    },
}));

const CountBar = (props) => {
    const ref = useRef(null);
    const classes = useStyles();
    const theme = useTheme();

    const [width, setWidth] = useState(0);
    const [color, setColor] = useState('');

    const { maxGroup, groupKeys } = useContext(GroupsContext);

    // value and size hook
    useEffect(() => {
        if (ref) {
            const fn = D3scaleLinear()
                .range([0, props.width || 50])
                .domain([0, props.maxGroup || maxGroup || 5]);
            setWidth(Math.max(fn(props.value), 5));
        }
    }, [props.value, props.width, maxGroup, props.maxGroup]);

    // key and color hook
    useEffect(() => {
        const colors = D3scaleOrdinal()
            .range(theme.SeverityColors.concat(theme.ChartColors))
            .domain(groupKeys);
        setColor(colors(props.colorKey));
    }, [props.colorKey, groupKeys, theme.ChartColors, theme.SeverityColors]);

    return (
        <span className={classes.root} ref={ref}>
            <StyledTooltip
                title={`${D3format(',.0f')(props.value)}`}>
                <a className={classes.bar}
                    onClick={props.onClick}
                    style={{
                        width,
                        backgroundColor: color,
                        color: theme.palette.getContrastText(color || '#ffffff'),
                        height: props.height || 7,
                        cursor: props.onClick ? 'pointer' : ''
                    }}>
                    {props.height > 10 && <span className={classes.value}>
                        {D3format(',.0f')(props.value)}
                    </span>}
                </a>
            </StyledTooltip>
        </span>
    );
};

CountBar.propTypes = {
    value: PropTypes.number.isRequired,
    colorKey: PropTypes.string.isRequired,
    height: PropTypes.number,
    width: PropTypes.number,
    onClick: PropTypes.func,
    // override max group here
    maxGroup: PropTypes.number,
};

export default CountBar;
